/**
 * MazeAppLauncher.tsx
 * 「迷路」アプリの起動画面。おしゃべりアプリ(ChatAppLauncher)と同じ app-card UI を使う。
 * ステージ(1〜3)を選んで「スタート」を押すと編集モードへ遷移する。
 */
import { useState } from 'react';
import { Play, Puzzle } from 'lucide-react';
import { MAZE_STAGES } from '@/flow/config/mazeStages';

export type MazeAppLauncherProps = {
  onLaunch: (stageId: number) => void;
};

export function MazeAppLauncher({ onLaunch }: MazeAppLauncherProps) {
  const [selectedStageId, setSelectedStageId] = useState(MAZE_STAGES[0].id);

  return (
    <section className="apps-panel" aria-labelledby="maze-app-panel-title">
      <article className="app-card">
        <div className="app-card__icon" aria-hidden="true">
          <Puzzle size={27} />
        </div>
        <div className="app-card__content">
          <h3 id="maze-app-panel-title">迷路</h3>
          <p>カードをつなげてロボットを動かし、迷路のゴールを目指します。</p>
        </div>
        <label className="app-card__select">
          ステージ
          <select
            value={selectedStageId}
            onChange={(event) => setSelectedStageId(Number(event.target.value))}
          >
            {MAZE_STAGES.map((stage) => (
              <option key={stage.id} value={stage.id}>{stage.name}</option>
            ))}
          </select>
        </label>
        <button
          type="button"
          className="app-card__launch"
          onClick={() => onLaunch(selectedStageId)}
        >
          <Play aria-hidden="true" size={16} fill="currentColor" />
          スタート
        </button>
      </article>
    </section>
  );
}
